import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Plus } from "lucide-react";
import { Container, Eyebrow, TextLink } from "./ui-kit";
import Reveal from "./Reveal";

export const FAQS = [
  {
    q: "Minimum sipariş miktarınız (MOQ) nedir?",
    a: "Ürün grubuna ve modele göre değişmekle birlikte esnek adetlerle çalışıyoruz. İhtiyacınızı ilettiğinizde size en uygun adet ve fiyatlandırmayı sunuyoruz. Numune ve küçük parti talepleriniz için de bize ulaşabilirsiniz.",
  },
  {
    q: "Numune gönderiyor musunuz?",
    a: "Evet. Renk, ölçü ve model tercihlerinizi ilettiğinizde numune çalışmasını aynı gün başlatıyoruz. İletişim formundan veya WhatsApp sipariş hattımızdan numune talebinizi iletebilirsiniz.",
  },
  {
    q: "Özel logo baskılı kot düğmesi ve toka üretiyor musunuz?",
    a: "Evet. Kendi tesisimizde özel logo, marka ve tasarım baskılı kot düğmesi, toka ve aksesuar üretimi yapıyoruz. Tasarımınızı gönderin, kalıp ve numune sürecini birlikte planlayalım.",
  },
  {
    q: "Ürünleriniz ihracata uygun mu?",
    a: "Tüm ürünlerimizi uluslararası kalite ve uyumluluk standartlarında üretiyoruz ve ihracata uygun ürün garantisi sunuyoruz. Üretimin her aşamasında kalite kontrol uygulanır.",
  },
  {
    q: "Teslimat süreniz ne kadar?",
    a: "Standart ürünlerde stok durumuna göre hızlı teslimat yapıyoruz; özel üretim ve baskılı işlerde süre model ve adete göre belirlenir. Siparişleriniz zamanında teslim edilerek işinizin aksamaması sağlanır.",
  },
];

const Faq = () => {
  const [open, setOpen] = useState(0);
  const ld = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section className="py-24 lg:py-28 bg-canvas border-t border-line" data-testid="faq-section">
      <Container className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-4 lg:sticky lg:top-32">
          <Reveal>
            <Eyebrow>Sıkça Sorulan Sorular</Eyebrow>
            <h2 className="font-display font-light text-[2rem] sm:text-[2.6rem] leading-[1.1] tracking-[-0.01em] text-ink mt-4">
              Aklınıza takılanlar
            </h2>
            <p className="text-ink2 leading-relaxed mt-5">
              Sipariş, numune ve üretim süreçlerimizle ilgili en çok merak edilenleri derledik. Aradığınızı bulamazsanız
              bize yazın.
            </p>
            <div className="mt-8">
              <TextLink to="/iletisim" data-testid="faq-contact-link">Soru sorun</TextLink>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-8" data-testid="faq-list">
          {FAQS.map((f, i) => {
            const on = open === i;
            return (
              <Reveal key={f.q} delay={(i % 5) * 60}>
                <div className="border-b border-line first:border-t">
                  <button
                    onClick={() => setOpen(on ? -1 : i)}
                    aria-expanded={on}
                    data-testid={`faq-question-${i}`}
                    className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                  >
                    <span className={`font-display text-[17px] sm:text-[19px] transition-colors ${on ? "text-brand" : "text-ink group-hover:text-brand"}`}>
                      {f.q}
                    </span>
                    <span className={`shrink-0 w-9 h-9 rounded-full border flex items-center justify-center transition-all duration-300 ${on ? "bg-brand border-brand text-white rotate-45" : "border-line text-ink2 group-hover:border-ink"}`}>
                      <Plus size={16} strokeWidth={2} />
                    </span>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-out ${on ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}
                    data-testid={`faq-answer-${i}`}
                  >
                    <div className="overflow-hidden">
                      <p className="text-ink2 text-[14.5px] leading-relaxed pb-7 pr-12 max-w-2xl">{f.a}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(ld)}</script>
      </Helmet>
    </section>
  );
};

export default Faq;
